import { getLCP } from 'web-vitals/base';

const onLargestContentfulPaint = response => {
  getLCP(lcp => response(lcp.value));
};

export default onLargestContentfulPaint;
